import {
    createSlice,
    PayloadAction,
    createAsyncThunk
  } from '@reduxjs/toolkit';
  import type { RootState } from 'app/store';
  import { getData } from 'utils/service';
  // declaring the types for our state
  export type DashboardState = {
    value: number;
    data: any;
    pending: boolean;
    error: boolean;
  };
  
  const initialState: DashboardState = {
    value: 0,
    data: {},
    pending: false,
    error: false,
  };

  // This action is what we will call using the dispatch in order to trigger the API call.
  export const getDashboardData = createAsyncThunk('api/dashboard', async () => {
    let response: any = await getData('dashboard', { });
    if (response.success === "true") {
      return response
    }
    return {};
  });
  
  export const saveDashboardData = createAsyncThunk('api/savedashboard', async () => {
    let response: any = await getData('dashboard', {  });
    if (response.success === "true") {
      return response
    }
    return {};
  });

  export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
  // The `reducers` field lets us define reducers and generate associated actions. 
  // In this example, 'increment', 'decrement' and 'incrementByAmount' are actions. They can be triggered from outside this slice, anywhere in the app. 
  // So for example, if we make a dispatch to the 'increment' action here from the index page, it will get triggered and change the value of the state from 0 to 1.
    reducers: {
      increment: state => {
  // Redux Toolkit allows us to write "mutating" logic in reducers. 
  // It doesn't actually mutate the state because it uses the Immer library, which detects changes to a "draft state" and produces a brand new immutable state based off those changes
        state.value++;
      },
      decrement: state => {
        state.value--;
      },
  // 'The increment by amount' action here, has one job and that is to take whatever value is passed to it and add that to state.value. 
  // The PayloadAction type here is used to declare the contents of `action.payload`
      incrementByAmount: (state, action: PayloadAction<number>) => {
        state.value += action.payload;
      },
    },

    extraReducers: builder => {
      builder
        .addCase(getDashboardData.pending, state => {
          state.pending = true;
        })
        .addCase(getDashboardData.fulfilled, (state, { payload }) => {
        // When the API call is successful and we get some data,the data becomes the `fulfilled` action payload
          state.pending = false;
          state.data = payload;
        })
        .addCase(getDashboardData.rejected, state => {
          state.pending = false;
          state.error = true;
        }).addCase(saveDashboardData.pending, state => {
          state.pending = true;
        })
        .addCase(saveDashboardData.fulfilled, (state, { payload }) => {
        // When the API call is successful and we get some data,the data becomes the `fulfilled` action payload
          state.pending = false;
          state.data = payload;
        })
        .addCase(saveDashboardData.rejected, state => {
          state.pending = false;
          state.error = true;
        });
    },

  });
  // Here we are just exporting the actions from this slice, so that we can call them anywhere in our app.
  export const {
    increment, 
    decrement, 
    incrementByAmount,
  } = dashboardSlice.actions;
  
  // calling the above actions would be useless if we could not access the data in the state. So, we use something called a selector which allows us to select a value from the state.
  export const selectDashboard = (state: RootState) => state.dashboard;
  
  // exporting the reducer here, as we need to add this to the store
  export default dashboardSlice.reducer;